// src/components/team/QuickStatusButton.jsx
import React from 'react';
import { Check } from 'lucide-react';

export const QuickStatusButton = ({
  option,
  isSelected,
  onClick,
  disabled = false,
  showLabel = true,
  size = 'default'
}) => {
  const sizeClasses = {
    small: 'px-3 py-2 text-sm',
    default: 'px-4 py-3 text-base',
    large: 'px-5 py-4 text-lg'
  };

  return (
    <button
      type="button"
      onClick={() => onClick(option)}
      disabled={disabled}
      className={`
        ${sizeClasses[size]}
        relative rounded-lg border-2 transition-all duration-200
        flex items-center gap-2 font-medium
        ${isSelected 
          ? 'border-current shadow-md scale-105' 
          : 'border-gray-200 hover:border-gray-300 hover:shadow-sm'
        }
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:scale-102'}
      `}
      style={{
        backgroundColor: isSelected ? `${option.color}15` : '#ffffff',
        color: isSelected ? option.color : '#374151'
      }}
      title={option.description}
    >
      {/* Icon/Emoji */}
      <span className="text-2xl leading-none">{option.icon}</span>
      
      {/* Label */}
      {showLabel && (
        <span className="font-medium">{option.label}</span>
      )}
      
      {/* Selected indicator */}
      {isSelected && (
        <Check 
          className="absolute -top-1 -right-1 h-5 w-5 bg-white rounded-full p-0.5" 
          style={{ color: option.color }}
        />
      )}
    </button>
  );
};